import React from 'react';

const CustomRedLoader: React.FC = () => {
    return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '300px', width: '100%' }}>
            <div className="spinner-border text-danger" role="status" style={{ width: '3rem', height: '3rem' }}>
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    );
};

export default CustomRedLoader;
